import * as React from 'react';
import { Layout as DashboardLayout } from '@/layouts/v2/layout';
import type { RouteObject } from 'react-router-dom';
import { Outlet } from 'react-router-dom';

import { paths } from '@/paths';
import { CommunitySettingsPage } from '@/pages/v2/settings/community-settings';
import { Layout as CommunitySettingsLayout } from '@/pages/v2/settings/community-settings/components/layout';
import CommunitySettingsImport from '@/pages/v2/settings/community-settings/import';
import CommunityActivityPage from '@/pages/v2/settings/community-settings/activity';
import { CommunityAmenitiesPage } from '@/pages/v2/settings/community-settings/amenities';
import { AmenityDetailPage } from '@/pages/v2/settings/community-settings/amenities/amenity';
import { CommunityReservationsPage } from '@/pages/v2/settings/community-settings/reservations';
import { ReservationDetailPage } from '@/pages/v2/settings/community-settings/reservations/reservation';
import CommunityPreferencesPage from '@/pages/v2/settings/community-settings/preferences';
import CommunityPaymentsPage from '@/pages/v2/settings/community-settings/payments';
import { CommunityRentalsPage } from '@/pages/v2/settings/community-settings/rentals';

const communitySettingsLayout = (
  <DashboardLayout>
    <CommunitySettingsLayout metadata={{ title: 'Community Settings' }}>
      <Outlet />
    </CommunitySettingsLayout>
  </DashboardLayout>
);

export const route: RouteObject = {
  path: 'settings/community',
  element: communitySettingsLayout,
  children: [
    {
      index: true,
      element: <CommunitySettingsPage />,
    },
    {
      path: 'import',
      element: <CommunitySettingsImport />,
    },
    {
      path: 'amenities',
      children: [
        {
          index: true,
          element: <CommunityAmenitiesPage />,
        },
        {
          path: ':amenityId',
          element: <AmenityDetailPage />,
        },
      ],
    },
    {
      path: 'reservations',
      children: [
        {
          index: true,
          element: <CommunityReservationsPage />,
        },
        {
          path: ':reservationId',
          element: <ReservationDetailPage />,
        },
      ],
    },
    {
      path: 'payments',
      element: <CommunityPaymentsPage />,
    },
    {
      path: 'preferences',
      element: <CommunityPreferencesPage />,
    },
    {
      path: 'rentals',
      element: <CommunityRentalsPage />,
    },
    {
      path: 'activity',
      element: <CommunityActivityPage />,
    },
  ],
};
